// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-app-banner {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 9999;
  background-color: #ffffff;
  border-bottom: 1px solid #e0e0e0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 14px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.banner-left {
  display: flex;
  align-items: center;
  flex: 1 1;
  min-width: 0;
}

.banner-close-btn {
  background: transparent;
  border: none;
  font-size: 20px;
  line-height: 1;
  color: #707070;
  cursor: pointer;
  margin-right: 8px;
  padding: 0 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-close-btn:hover {
  color: #333333;
}

.banner-app-icon {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 12px;
  flex-shrink: 0;
  background-color: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.banner-text-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
}

.banner-app-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f0f0f;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner-app-subtitle {
  font-size: 12px;
  color: #606060;
  font-weight: 400;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner-right {
  margin-left: 12px;
  flex-shrink: 0;
}

.banner-open-btn {
  background-color: #1a73e8;
  color: #ffffff;
  border: none;
  border-radius: 18px;
  padding: 6px 18px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
  display: inline-block;
  text-align: center;
  outline: none;
}

.banner-open-btn:active {
  background-color: #1557b0;
  transform: scale(0.97);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing/components/MobileAppBanner/MobileAppBanner.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gCAAgC;EAChC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;EACtB,gGAAgG;AAClG;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,2DAA2D;EAC3D,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB","sourcesContent":[".mobile-app-banner {\r\n  position: sticky;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  width: 100%;\r\n  z-index: 9999;\r\n  background-color: #ffffff;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 8px 14px;\r\n  box-sizing: border-box;\r\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\r\n}\r\n\r\n.banner-left {\r\n  display: flex;\r\n  align-items: center;\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.banner-close-btn {\r\n  background: transparent;\r\n  border: none;\r\n  font-size: 20px;\r\n  line-height: 1;\r\n  color: #707070;\r\n  cursor: pointer;\r\n  margin-right: 8px;\r\n  padding: 0 2px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.banner-close-btn:hover {\r\n  color: #333333;\r\n}\r\n\r\n.banner-app-icon {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 8px;\r\n  object-fit: cover;\r\n  margin-right: 12px;\r\n  flex-shrink: 0;\r\n  background-color: #ffffff;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.banner-text-info {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  min-width: 0;\r\n}\r\n\r\n.banner-app-title {\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  color: #0f0f0f;\r\n  line-height: 1.2;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.banner-app-subtitle {\r\n  font-size: 12px;\r\n  color: #606060;\r\n  font-weight: 400;\r\n  margin-top: 2px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.banner-right {\r\n  margin-left: 12px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.banner-open-btn {\r\n  background-color: #1a73e8;\r\n  color: #ffffff;\r\n  border: none;\r\n  border-radius: 18px;\r\n  padding: 6px 18px;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  letter-spacing: 0.4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease, transform 0.1s ease;\r\n  display: inline-block;\r\n  text-align: center;\r\n  outline: none;\r\n}\r\n\r\n.banner-open-btn:active {\r\n  background-color: #1557b0;\r\n  transform: scale(0.97);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
